import React, { Component } from 'react';
import { RichText } from '../../../components/richTextOptions';
import PgHomeSidebar from './PgHomeSidebar';
import PgSidebar from './PgSidebar';
import PgSidebarImage from './PgSidebarImage';

class PgArticle extends Component {
     render() {
          const { article, homeSidebar } = this.props;
          return (
               <section className={`pg-article-content`}>
                    <div className="container">
                         <div className="row">
                              <div className="col-lg-9">
                                   <div className="pg-article-wrapper">
                                        <div className="pg-title-social">
                                             {article.articleName && <h1>{article.articleName}</h1>}
                                             <div className="social">
                                                  <div className="addthis_toolbox">
                                                       <div className="custom_images">
                                                            <a className="addthis_button_linkedin animation">
                                                                 <img src="/images/pet-gazette/linkedin.png" alt="Share to Linkedin" />
                                                            </a>
                                                            <a className="addthis_button_facebook animation">
                                                                 <img src="/images/pet-gazette/facebook.png" alt="Share to Facebook" />
                                                            </a>
                                                            <a className="addthis_button_twitter animation">
                                                                 <img src="/images/pet-gazette/twitter.png" alt="Share to Twitter" />
                                                            </a>
                                                            <a className="addthis_button_more animation">
                                                                 <img src="/images/pet-gazette/youtube.png" alt="More..." />
                                                            </a>
                                                       </div>
                                                  </div>
                                             </div>
                                        </div>
                                        {article.body && <RichText data={article.body}></RichText>}
                                   </div>
                              </div>
                              <div className="col-lg-3 sidebar-content">
                                   {homeSidebar ? <PgHomeSidebar activeArticle={article} /> : <PgSidebar activeArticle={article} category={article.category} />}
                                   <div className="image-layout">
                                        <PgSidebarImage />
                                        {/* <a href="/veterinarians/"><img src="/images/hrpg.jpg" alt="Add pet insurance to your voluntary benefit package" /></a> */}
                                   </div>
                              </div>
                         </div>
                    </div>
               </section>
          )
     }
}

export default PgArticle;
